module.exports = __webpack_public_path__ + "banquet/components/Navbar/images/nav_heart_selected.0a5f7efc618ca7e2fa69c65fc7a15b45.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Navbar/images/nav_heart_selected.png
// module id = 1682
// module chunks = 1